import { ExclamationCircleFilled } from "@ant-design/icons"
import { Tooltip, type TooltipProps } from "antd"
import React from "react"
import { AlertTriangle } from "react-feather"

interface HoverableInfoProps {
    message: TooltipProps["title"]
    iconClassName?: string
    overlayInnerStyle?: React.CSSProperties
    placement?: TooltipProps["placement"]
    type?: "info" | "warn"
    iconOverride?: React.ReactNode
}
export const HoverableInfo = ({ message, iconClassName = "ml-6", overlayInnerStyle = {}, placement = "top", type = "info", iconOverride }: HoverableInfoProps) => {
    let icon

    if (iconOverride) {
        icon = iconOverride
    } else {
        icon =
            type === "warn" ? (
                <AlertTriangle fill="#FBAC3B" size={18} stroke="#FFFFFF" className={iconClassName} />
            ) : (
                <ExclamationCircleFilled className={iconClassName} style={{ color: "#3866FF" }} />
            )
    }

    const getPopupContainer = (triggerNode: HTMLElement): HTMLElement => triggerNode.closest(".ant-modal-content") || document.body

    return (
        <Tooltip getPopupContainer={getPopupContainer} title={message} placement={placement} className="align-middle" overlayInnerStyle={overlayInnerStyle}>
            {icon}
        </Tooltip>
    )
}
